// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"63":"a5ae7327","647":"d32dc65d"}[chunkId] + ".js";
};